<div class="error-message-container">
    <app-error-message *ngIf="message!=''" [message]="message"></app-error-message>
</div>
<h2>{{title}} </h2>
<!-- (keyup.enter)="passWordForm.valid && (CaptchaNeeded ? captchaRef.execute() : login())" -->
<form [formGroup]="passWordForm" id="idCardForm"  autocomplete="off">
    <!-- <input type="password" style="display:none ;"/> -->
    <div class="inputs-button-wrapper">
        <label for="userName" class="eds-input-label">קוד המשתמש שלך</label>
        <div class='inputs-container'>          
            <input autofocus  autocomplete="off"  #userName id="userName" formControlName="userName" type="text" (input) = "clearCursor('userName');message!='' && resetMassage()" 
            [ngClass]="{inputInvalid:hebrewCharater == userName.id ||isValidFormSubmitted && passWordForm.controls['userName'].errors?.required}" 
            pInputText (hebrewCharater)="hebrewCharater=$event" (capsLock)="capsOn=$event" (focusout)="clearDirective()">
            <p-message severity="error" text="קוד המשתמש שלך לא חוקי" *ngIf="userName.invalid && userName.touched">
            </p-message>
            <label *ngIf="capsOn == userName.id" class="caps-in-on">Caps Lock פעיל</label>
            <p-message severity="error" text="אין להקליד תווים בעברית" *ngIf="hebrewCharater == userName.id">
            </p-message>
            <p-message severity="error" text="שדה חובה" *ngIf="isValidFormSubmitted && passWordForm.controls['userName'].errors?.required">
            </p-message>
        </div>
        

        <label for="password" class="eds-input-label">סיסמה</label>
        <div class='inputs-container'>
            <div class="password-contianer">
                <input #password type="password"  autocomplete="new-password" onfocus="this.removeAttribute('readonly');" readonly id="password" formControlName="password" maxlength="16"  (input) = "clearCursor('password'); message!='' && resetMassage()" 
                 pInputText togglePassword  (focusout)="clearDirective()"
                 (hebrewCharater)="hebrewCharater=$event" (capsLock)="capsOn=$event" 
                [ngClass]="{inputInvalid:hebrewCharater == password.id || isValidFormSubmitted && passWordForm.controls['password'].errors?.required}" >
            </div>
            <p-message severity="error" text="סיסמה לא תקינה" *ngIf="password.invalid && password.touched">
            </p-message>
            <p-message severity="error" text="שדה חובה"  *ngIf="isValidFormSubmitted && passWordForm.controls['password'].errors?.required">
            </p-message>
            <label *ngIf="capsOn == password.id" class="caps-in-on">Caps Lock פעיל</label>
            <p-message  severity="error" text=" אין להקליד תווים בעברית" *ngIf="hebrewCharater == password.id">
            </p-message>
        </div>
        <div class="container-button container-fluid">
            <p-button type="submit"  label={{button}} (onClick)="CaptchaNeeded ? captchaRef.execute() : login()">
            </p-button>
        </div>
    </div>
    <re-captcha #captchaRef="reCaptcha" (resolved)="$event && login($event)" siteKey="{{this.sitekey}}" size="invisible" ></re-captcha> 
</form>
<p class="create-password">
    אין לך קוד משתמש וסיסמה?
    <a target='_blank' rel="noopener noreferrer" href={{this.resetPassword}}>
        לקביעת סיסמה
    </a>
</p>
<p class="update-phone" *ngIf="showUpdatePhone">
    <a target='_blank' rel="noopener noreferrer" href={{this.updatePhone}}>
        לעדכון טלפון נייד
    </a>
</p>

<app-loader *ngIf="loader"  [text]="'המערכת בודקת את הנתונים'"></app-loader>